export default __webpack_public_path__ + "images/f2276f7960095b167a765516bfe12feb-ingredients-for-friendships.svg";